import React from 'react';
import { connect } from 'react-redux';

import Chrome from '../chrome/Chrome';
import style from '../goldenRecords/GoldenRecord.module.scss';
import GoldenRecords from '../goldenRecords/GoldenRecords';
import GoldenRecordsSidebar from '../goldenRecords/GoldenRecordsSidebar';
import { AppState } from '../stores/MainStore';

const GoldenRecordsPage = connect((state: AppState) => {
  const { goldenRecords: { showSidebar } } = state;
  return { showSidebar };
})(({ showSidebar }) => {
  return (
    <Chrome
      className={style.page}
      rightSidebar={<GoldenRecordsSidebar />}
      isExpanded={showSidebar}
    >
      <GoldenRecords />
    </Chrome>
  );
});

export default GoldenRecordsPage;
